import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";
import { AddSubCategory } from "../../../redux/services/subCategoriesService/subCategories.Services";
import { ActiveCategoryList } from "../../../redux/services/categoriesService/categories.Services";
import {
  successToast,
  errorToast,
} from "../../../Utils/toast";

function CreateSubCategory() {
  const dispatch = useDispatch();

  const [categories, setCategories] = useState([]);

  const [formData, setFormData] = useState({
    category_id: "",
    name: "",
  });

  const [errors, setErrors] = useState({
    category_id: "",
    name: "",
  });

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await ActiveCategoryList();

      if (res?.success) {
        setCategories(res.data || []);
      
      }
    } catch (error) {
      console.log(error);
      errorToast("Something went wrong");
    }
  };

    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

    const validateForm = () => {
    const newErrors = {};

    if (!formData.category_id) {
      newErrors.category_id = ["Please select category"];
    }

    if (!formData.name.trim()) {
      newErrors.name = ["Please enter sub category name"];
    }

    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

   const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    try {
      const res = await AddSubCategory(formData);
      if (res?.data?.success) {
        successToast(res.data.message);
        dispatch(refreshProductList());
        dispatch(closeProductModal());
      }
       else {
        const errorData = res?.data || res || {};
        if (errorData?.errors) {
          setErrors(errorData.errors);
        } else {
          errorToast(errorData?.message || "Something went wrong");
        }
      }
    } catch (error) {
      if (error?.response?.status === 422) {
        const apiErrors = error.response.data?.errors || {};
        setErrors(apiErrors);
      } else {
        errorToast(error?.response?.data?.message || "Something went wrong");
      }
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="form-label">
          Select Category
        </label>
        <select
          name="category_id"
          value={formData.category_id}
          onChange={handleChange}
           className={`form-control ${errors?.category_id ? "is-invalid" : ""}`}
        >
          <option value="">
            Select Category
          </option>
          {categories?.map((item) => (
            <option
              key={item.id}
              value={item.id}
            >
              {item.name}
            </option>
          ))}
        </select>
        {errors?.category_id && (
          <div className="invalid-feedback d-block">
            {Array.isArray(errors.category_id) ? errors.category_id[0] : errors.category_id}
          </div>
        )}
      </div>

      {/* Sub Category */}

      <div className="mb-3">
        <label className="form-label">
          Sub Category Name
        </label>

        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
              className={`form-control ${errors?.name ? "is-invalid" : ""}`}

        />

       {errors?.name && (
          <div className="invalid-feedback d-block">
            {Array.isArray(errors.name) ? errors.name[0] : errors.name}
          </div>
        )}
      </div>

      <button
        type="submit"
        className="btn btn-primary"
      >
        Create Sub Category
      </button>
    </form>
  );
}

export default CreateSubCategory;